export default __webpack_public_path__ + "static/N0274-10eda8eb70b04af8daab32fcc0b13409.png";